export const BLOG_POSTS = [
  {
    slug: "csopog-a-csap-okok-megoldasok",
    title: "Csöpög a csap? 5 gyakori ok és mikor hívjon szakembert",
    description:
      "Miért csöpög a csap és mit tehet otthon? A leggyakoribb 5 ok, egyszerű ellenőrzések, és mikor érdemes vízszerelőt hívni Budapesten vagy Keszthelyen.",
    category: "Vízszerelés",
    date: "2026-10-12",
    readMin: 5,
    cover:
      "https://images.unsplash.com/photo-1610278764397-388d11c35ddb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Csöpögő csaptelep közelről",
    excerpt:
      "Egy csöpögő csap évente több ezer liter vizet és felesleges költséget jelent. Nézzük a leggyakoribb okokat és azt, mit tud otthon ellenőrizni.",
    sections: [
      {
        h: "Miért nem mindegy, ha csöpög?",
        body: [
          "Egy folyamatosan csöpögő csap napi szinten tíz-húsz liter vizet is elpazarolhat, ami egy év alatt jelentős vízdíj-többlet. Ráadásul az állandó nedvesség a csaptelep és a mosdó környékén vízkövesedést és penészt is okozhat.",
          "A jó hír, hogy a csöpögés oka a legtöbb esetben egyszerű, és korai beavatkozással olcsón orvosolható.",
        ],
      },
      {
        h: "5 leggyakoribb ok",
        body: ["A tapasztalat szerint a csöpögés hátterében szinte mindig az alábbiak egyike áll:"],
        list: [
          "Elhasználódott tömítés vagy O-gyűrű a csaptelepben",
          "Kopott kerámiabetét (a karos csapoknál)",
          "Vízköves, berágódott szelepülés",
          "Meglazult vagy rosszul meghúzott hollandi kötés",
          "Túl magas hálózati víznyomás, amely terheli a tömítéseket",
        ],
      },
      {
        h: "Mit ellenőrizhet otthon?",
        body: [
          "Mielőtt bármihez hozzáfog, zárja el a mosdó alatti sarokszelepet. Ha nincs sarokszelep, a lakás főelzáróját használja. Egy puha ronggyal törölje szárazra a csapot, és figyelje meg, pontosan honnan szivárog a víz: a kifolyónál, a kar alatt vagy a fali csatlakozásnál.",
          "A kifolyónál lévő apró csöpögés általában a betét vagy tömítés cseréjét jelenti, míg a fali csatlakozásnál megjelenő nedvesség komolyabb, szakember által javítandó probléma lehet.",
        ],
      },
      {
        h: "Mikor hívjon szakembert?",
        body: [
          "Ha a sarokszelep elzárása után is folyik a víz, ha a fali bekötésnél szivárog, vagy ha a csap szétszerelése után nem találja a hiba okát, érdemes vízszerelőt hívni. A megfelelő betét vagy tömítés kiválasztása csaptípusonként eltér, és a rossz alkatrész többet árthat, mint használ.",
          "A Szuper Szaki Budapesten és Keszthely környékén is vállalja a csaptelepek javítását és cseréjét – kérjen ingyenes árajánlatot az oldal alján található űrlapon.",
        ],
      },
    ],
  },
  {
    slug: "wc-tartaly-folyamatosan-folyik",
    title: "Folyamatosan folyik a WC-tartály? Okok és megoldások",
    description:
      "A WC-tartály állandóan folyik a kagylóba? Nézze meg a leggyakoribb okokat – úszószelep, gumiharang, vízkő – és mikor kell szakembert hívni.",
    category: "Vízszerelés",
    date: "2026-10-05",
    readMin: 4,
    cover:
      "https://images.unsplash.com/photo-1521207418485-99c705420785?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Folyó víz a csapból",
    excerpt:
      "A szivárgó WC-tartály az egyik leggyakoribb, mégis legtöbb vizet pazarló hiba. Megmutatjuk, mi okozza és mit lehet tenni.",
    sections: [
      {
        h: "Hogyan ismeri fel a hibát?",
        body: [
          "Ha folyamatos, vékony vízcsíkot lát a WC-kagyló hátsó falán, vagy halk csobogást hall öblítés nélkül is, akkor a tartály szivárog. Egy egyszerű teszt: cseppentsen néhány csepp ételfestéket a tartályba, és várjon 15 percet öblítés nélkül. Ha a festék megjelenik a kagylóban, a leeresztő gumiharang nem zár tökéletesen.",
        ],
      },
      {
        h: "A leggyakoribb okok",
        body: ["A folyamatos folyás mögött jellemzően ezek állnak:"],
        list: [
          "Elkopott vagy elmozdult gumiharang (leeresztő szelep)",
          "Hibás úszószelep, amely nem állítja le a feltöltést",
          "Vízköves alkatrészek, amelyek nem zárnak",
          "Rosszul beállított vízszint a tartályban",
        ],
      },
      {
        h: "Mit tehet önállóan?",
        body: [
          "Zárja el a tartály melletti sarokszelepet, és vegye le a tartály fedelét. Ellenőrizze, hogy az úszó szabadon mozog-e, és hogy a gumiharang tisztán, lerakódás nélkül ül-e a helyén. Sok esetben a vízkő eltávolítása vagy az alkatrész visszaigazítása ideiglenesen megoldja a problémát.",
        ],
      },
      {
        h: "Mikor érdemes szakembert hívni?",
        body: [
          "A modern tartályszerelvények típusfüggőek, és a nem megfelelő alkatrész gyorsan újabb szivárgáshoz vezet. Ha a tisztítás után is folyik, vagy bizonytalan az alkatrész kiválasztásában, bízza szakemberre. A Szuper Szaki gyorsan cseréli a tartályszerelvényt, és pontosan beállítja a vízszintet – kérjen árajánlatot még ma.",
        ],
      },
    ],
  },
  {
    slug: "radiator-nem-melegszik-legtelenites",
    title: "Nem melegszik a radiátor? Légtelenítés lépésről lépésre",
    description:
      "Hideg marad a radiátor teteje, vagy bugyborékol? Így légtelenítse helyesen a fűtőtestet, és mikor jelez komolyabb fűtési problémát a hiba.",
    category: "Fűtésszerelés",
    date: "2026-09-28",
    readMin: 6,
    cover:
      "https://images.pexels.com/photos/36344878/pexels-photo-36344878.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1200",
    coverAlt: "Fehér radiátor a falon",
    excerpt:
      "Ha a radiátor alul meleg, de felül hideg marad, szinte biztosan levegő van a rendszerben. A légtelenítés egyszerű – megmutatjuk, hogyan.",
    sections: [
      {
        h: "Miért hideg a radiátor teteje?",
        body: [
          "A fűtési rendszerben idővel levegő gyűlik össze, amely a radiátor felső részében reked meg. Mivel a levegő nem vezeti jól a hőt, a fűtőtest alul meleg lesz, felül viszont hideg marad. Ez rontja a fűtés hatásfokát és növeli a gázszámlát.",
        ],
      },
      {
        h: "A légtelenítés lépései",
        body: ["A légtelenítéshez elég egy radiátorkulcs és egy edény vagy rongy a kicsöpögő víznek:"],
        list: [
          "Kapcsolja le a keringtető szivattyút, és hagyja kissé hűlni a rendszert",
          "Tegyen edényt a radiátor légtelenítő szelepe alá",
          "Lassan nyissa a szelepet a kulccsal – sziszegő hangot fog hallani",
          "Amikor egyenletesen, levegő nélkül folyik a víz, zárja el a szelepet",
          "Ellenőrizze a kazán nyomását, és szükség esetén töltsön utána",
        ],
      },
      {
        h: "Ellenőrizze a rendszernyomást",
        body: [
          "A légtelenítés után a kazán nyomása csökkenhet. A legtöbb lakossági rendszer ideális hidegnyomása 1,0–1,5 bar között van. Ha a nyomás túl alacsony, a fűtés nem melegít megfelelően; ha gyakran kell utántölteni, az szivárgásra utalhat.",
        ],
      },
      {
        h: "Mikor jelez komolyabb hibát?",
        body: [
          "Ha minden radiátort légtelenített, de egy fűtőtest továbbra is hideg, az iszaposodásra, eldugult szelepre vagy keringtetési problémára utalhat. Ilyenkor rendszerátmosásra vagy szakszerű beállításra lehet szükség.",
          "A Szuper Szaki Budapesten és Keszthely környékén is vállalja a fűtésrendszerek bemérését, légtelenítését és javítását – forduljon hozzánk bizalommal.",
        ],
      },
    ],
  },
  {
    slug: "csotores-azonnali-teendok",
    title: "Csőtörés otthon: azonnali teendők a nagyobb kár előtt",
    description:
      "Csőtörés vagy nagyobb szivárgás esetén minden perc számít. Lépésről lépésre, mit tegyen azonnal, hogyan csökkentse a kárt, és kit hívjon.",
    category: "Vészhelyzet",
    date: "2026-09-20",
    readMin: 5,
    cover:
      "https://images.unsplash.com/photo-1542013936693-884638332954?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Kiömlő víz a mosdónál",
    excerpt:
      "A csőtörés gyorsan komoly vízkárt okozhat. Ebben a rövid útmutatóban összeszedtük, mit tegyen az első percekben.",
    sections: [
      {
        h: "1. Zárja el a vizet azonnal",
        body: [
          "A legfontosabb lépés a lakás főelzáró csapjának elzárása. Érdemes előre tudni, hol található – jellemzően a bejárat közelében, a vízóra mellett. Ha csak egy csap vagy WC szivárog, a helyi sarokszelep elzárása is elég lehet.",
        ],
      },
      {
        h: "2. Áramtalanítson, ha szükséges",
        body: [
          "Ha a víz elektromos készülékek, konnektorok vagy a biztosítótábla közelébe jut, biztonsági okból kapcsolja le az érintett áramkört. A víz és az elektromosság együtt életveszélyes.",
        ],
      },
      {
        h: "3. Csökkentse a kárt",
        body: [
          "Itassa fel a vizet, helyezzen edényt a csepegő hely alá, és mentse ki az értékeket a nedves területről. Ha a szomszédokat is érintheti a szivárgás, jelezze nekik mielőbb.",
        ],
      },
      {
        h: "4. Hívjon szakembert",
        body: [
          "A rejtett csőtörések bemérése és javítása szaktudást igényel, különösen, ha a cső a falban vagy a padlóban fut. A Szuper Szaki gyorsan kiszáll Budapesten és Keszthely környékén, bemérés után a lehető legkisebb bontással javítja a hibát.",
        ],
      },
    ],
  },
  {
    slug: "futesrendszer-karbantartas-tel-elott",
    title: "Fűtésrendszer-karbantartás: így készítse fel a telet",
    description:
      "Néhány egyszerű lépéssel elkerülheti a téli fűtési meglepetéseket. Ellenőrzési lista a szezon előtt: nyomás, légtelenítés, radiátorok, kazán.",
    category: "Fűtésszerelés",
    date: "2026-10-18",
    readMin: 5,
    cover:
      "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1200",
    coverAlt: "Kazán karbantartása közben",
    excerpt:
      "A fűtési szezon előtti ellenőrzés sok bosszúságtól és váratlan költségtől óvhatja meg. Íme egy egyszerű lista.",
    sections: [
      {
        h: "Miért fontos a szezon előtti ellenőrzés?",
        body: [
          "A fűtés jellemzően akkor mondja fel a szolgálatot, amikor a leghidegebb van és a legnagyobb a terhelés. Egy nyár végi, ősz eleji átnézéssel a kis hibák még időben kiderülnek, mielőtt nagyobb problémává nőnék ki magukat.",
        ],
      },
      {
        h: "Őszi ellenőrzési lista",
        body: ["A szezon előtt érdemes végigmenni az alábbiakon:"],
        list: [
          "Ellenőrizze a kazán nyomását (jellemzően 1,0–1,5 bar hidegen)",
          "Légtelenítse a radiátorokat, ha felül hidegek maradnak",
          "Indítsa el a fűtést néhány percre, és figyelje a szokatlan zajokat",
          "Nézze át a látható csöveket és szelepeket szivárgás után kutatva",
          "Figyelje a termosztát és a szabályozás megfelelő működését",
        ],
      },
      {
        h: "Mit bízzon szakemberre?",
        body: [
          "A gázkészülékek éves felülvizsgálatát és a rendszer átmosását mindig képzett szakember végezze. Az iszaposodott rendszer rosszabb hatásfokkal, magasabb költséggel üzemel, és idővel károsítja a kazánt és a szivattyút.",
        ],
      },
      {
        h: "Segítünk felkészülni",
        body: [
          "A Szuper Szaki vállalja a fűtésrendszerek átnézését, beállítását és javítását Budapesten és Keszthely környékén. Kérjen árajánlatot időben, hogy a hidegben már ne érje meglepetés.",
        ],
      },
    ],
  },
  {
    slug: "vizko-megelozes-csapok-futes",
    title: "Vízkő a vízrendszerben: hogyan előzze meg a bajt?",
    description:
      "A vízkő lassan tönkreteszi a csaptelepeket, bojlert és fűtést. Megmutatjuk, hogyan ismeri fel, és milyen egyszerű lépésekkel előzheti meg a károkat.",
    category: "Karbantartás",
    date: "2026-09-14",
    readMin: 4,
    cover:
      "https://images.unsplash.com/photo-1644916925497-109cbd92087d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Modern fürdőszobai csaptelep",
    excerpt:
      "A kemény víz okozta vízkövesedés az egyik leggyakoribb, lassan jelentkező, de költséges probléma a háztartásokban. Így lassíthatja le.",
    sections: [
      {
        h: "Hogyan ismeri fel a vízkövet?",
        body: [
          "A fehéres, kérges lerakódás a csapok, zuhanyfejek és a vízforraló körül árulkodó jel. A vízkő szűkíti a csöveket, rontja a csaptelepek zárását, és a bojlerben, fűtésben lerakódva csökkenti a hatásfokot.",
        ],
      },
      {
        h: "Megelőzés egyszerű lépésekkel",
        body: ["Néhány szokással sokat tehet a vízkövesedés ellen:"],
        list: [
          "Rendszeresen tisztítsa a perlátorokat és zuhanyfejeket",
          "Fontolja meg vízlágyító vagy vízkőmentesítő beépítését kemény vizű területen",
          "Ne állítsa a bojlert feleslegesen magas hőfokra, mert gyorsítja a kiválást",
          "Figyelje a csökkenő víznyomást, ami eltömődő csőre utalhat",
        ],
      },
      {
        h: "Mikor kell beavatkozni?",
        body: [
          "Ha a víznyomás érezhetően csökken, a csapok nehezen zárnak, vagy a bojler lassabban melegít, a vízkő már komolyabb mértékű lehet. Ilyenkor a szerelvények tisztítása vagy cseréje, illetve vízlágyító beépítése a megoldás.",
          "A Szuper Szaki segít felmérni a rendszert és javaslatot tenni a megfelelő megoldásra Budapesten és Keszthely környékén.",
        ],
      },
    ],
  },
];

export const BLOG_FAQ = [
  {
    q: "Milyen területen vállal munkát a Szuper Szaki?",
    a: "Budapesten és vonzáskörzetében, valamint Keszthelyen és a Balaton nyugati medencéjében (Hévíz, Gyenesdiás, Vonyarcvashegy és környéke) is vállalunk víz- és fűtésszerelést.",
  },
  {
    q: "Milyen munkákat végez?",
    a: "Vízvezeték-szerelést, csapok, szifonok és WC-tartályok javítását és cseréjét, csőtörések és szivárgások javítását, valamint fűtésrendszerek és radiátorok szerelését, karbantartását.",
  },
  {
    q: "Hogyan kérhetek árajánlatot?",
    a: "Töltse ki a weboldal alján található árajánlatkérő űrlapot a nevével, e-mail-címével és telefonszámával, vagy hívjon minket telefonon. Hamarosan felvesszük Önnel a kapcsolatot.",
  },
  {
    q: "Sürgős csőtörés esetén is tudnak segíteni?",
    a: "Igen, igyekszünk gyorsan kiszállni. Sürgős esetben a leggyorsabb, ha telefonon keres minket, így azonnal tudunk időpontot egyeztetni.",
  },
];
